<template>
  <div>
    <a-card>
      <a-page-header :loading="loading" :sub-title="`#${artifactData.id}`" :title="artifactData.name" @back="() => $router.go(-1)">
        <div class="content">
          <div class="main">
            <a-descriptions size="small" :column="2">
              <a-descriptions-item label="仓库分类"> {{ artifactData.category }} </a-descriptions-item>
              <a-descriptions-item label="仓库地址"> {{ artifactData.registry_url }} </a-descriptions-item>
              <a-descriptions-item label="仓库描述"> {{ artifactData.description }} </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <template slot="footer">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="版本列表">
              <div class="customer-filter">
                <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
                  <a-row :gutter="24">
                    <a-col :span="6">
                      <a-form-model-item label="版本">
                        <a-input v-model="filterForm.version" placeholder="版本" class="form-model-item" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-model-item label="Commit">
                        <a-input v-model="filterForm.commit_id" placeholder="Commit" class="form-model-item" @change="onSearch" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="6" class="filter-right">
                      <a-button type="primary" @click="getArtifactVersionList">查询</a-button>
                      <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
                    </a-col>
                  </a-row>
                </a-form-model>
              </div>
              <div>
                <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
                  <span slot="creator" slot-scope="text, record">
                    <span v-if="record.creator">
                      <a-avatar :size="24" :src="record.creator.avatar_url" /> <span class="creator-nickname">{{ record.creator.nickname }} </span>
                    </span>
                  </span>
                  <span slot="expandedRowRender" slot-scope="record" style="white-space: pre-wrap; margin: 0">
                    <a-descriptions size="small" :column="1">
                      <a-descriptions-item label="制品地址">{{ `${record.registry_url}/${record.namespace}/${record.artifact_name}:${record.version}` }} </a-descriptions-item>
                      <a-descriptions-item label="关联信息">
                        <span v-if="!record.issues">--</span>
                        <div v-for="issue in record.issues" :key="issue.key">
                          <a class="custom-link" :href="issueLink(issue)" target="_blank">{{ issue.key }} {{ issue.title }} </a>
                        </div>
                      </a-descriptions-item>
                      <a-descriptions-item label="提交信息">{{ record.message }} </a-descriptions-item>
                    </a-descriptions>
                  </span>
                  <span slot="action" slot-scope="text, record">
                    <a-button type="link" @click="onDetail(record)">查看</a-button>
                  </span>
                </a-table>
              </div>
            </a-tab-pane>
          </a-tabs>
        </template>
      </a-page-header>
    </a-card>
  </div>
</template>
<script>
import { artifactVersionList, artifactDetail } from '@/api/system/artifact';
const columns = [
  {
    title: '版本',
    dataIndex: 'version',
    key: 'version',
    width: 180
  },
  {
    title: 'Git标签',
    dataIndex: 'git_tag_name',
    key: 'git_tag_name',
    width: 180,
    customRender: text => {
      return text || '--';
    }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 140,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '命名空间',
    dataIndex: 'namespace',
    key: 'namespace',
    width: 140
  },
  {
    title: 'Commit',
    dataIndex: 'commit_id',
    key: 'commit_id'
  },
  {
    title: '更新时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 180
  }
];
export default {
  data() {
    return {
      loading: false,
      detailLoading: false,
      artifactId: this.$route.query.artifactId || null,
      filterForm: {
        service_id: null,
        artifact_id: this.$route.query.artifactId || null,
        version: null,
        page_number: 1,
        page_size: 10
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      artifactData: {},
      tableData: [],
      columns
    };
  },
  computed: {
    issueLink() {
      return record => {
        if (record.issue_type === 'task') {
          const route = this.$router.resolve({
            name: 'page:project:task:detail',
            query: { taskId: record.id },
            params: { project_id: record.project_id }
          });
          return route.href;
        } else {
          const route = this.$router.resolve({
            name: 'page:project:quality:issue:detail',
            query: { issueId: record.id },
            params: { project_id: record.project_id }
          });
          return route.href;
        }
      };
    }
  },
  created() {
    this.getArtifactDetail();
    this.getArtifactVersionList();
  },
  methods: {
    reset() {
      this.filterForm = {
        name: null,
        category: null,
        artifact_id: this.artifactId,
        page_size: this.pagination.pageSize,
        page_number: 1
      };
      this.getArtifactVersionList();
    },

    getArtifactDetail() {
      this.detailLoading = true;
      artifactDetail({ artifact_id: this.artifactId }).then(res => {
        this.artifactData = res.data;
        this.detailLoading = false;
      });
    },

    getArtifactVersionList() {
      this.loading = true;
      artifactVersionList(this.filterForm).then(res => {
        this.tableData = res.data.items;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },

    handleTableChange(pagination) {
      pagination.current = pagination.pageSize !== this.pagination.pageSize ? 1 : pagination.current;
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getArtifactVersionList();
    },

    onSearch() {
      this.filterForm.page_number = 1;
      this.getArtifactVersionList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-page-header {
  padding: 0px;
}

/deep/ .customer-filter {
  margin: 16px 0;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.creator-nickname {
  margin-left: 4px;
  line-height: 32px;
}
/deep/.ant-descriptions-item > span {
  display: inline-table;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
